import { render, staticRenderFns } from "./yesMenu.vue?vue&type=template&id=661973d1&scoped=true"
import script from "./yesMenu.vue?vue&type=script&lang=js"
export * from "./yesMenu.vue?vue&type=script&lang=js"
import style0 from "./yesMenu.vue?vue&type=style&index=0&id=661973d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661973d1",
  null
  
)

export default component.exports